<div class="request-item mood-request my-2 mx-auto px-4 py-4">
    <div class="mood-picker-pills position-relative">
        <div id="moodPickerCircle"></div>
        <h5>{{ 'add_mood_box.mood_question' | translate}}</h5>
        <ul class="nav nav-pills py-2 px-5 mb-3 d-flex justify-content-between align-items-center" id="mood_update">
            <li [ngClass]="{active: requestedMood.mood == 'excellent'}" (click)="createMood('excellent')">
                <a class="nav-pills-item" href="javascript:void(0)">
                    <i class="icon-smileys-excellent"></i>
                    <p>{{'excellent' | translate}}</p>
                </a>
            </li>
            <li [ngClass]="{active: requestedMood.mood == 'good'}" (click)="createMood('good')">
                <a class="nav-pills-item" href="javascript:void(0)">
                    <i class="icon-smileys-good"></i>
                    <p>{{'good' | translate}}</p>
                </a>
            </li>
            <li [ngClass]="{active: requestedMood.mood == 'average'}" (click)="createMood('average')">
                <a class="nav-pills-item" href="javascript:void(0)">
                    <i class="icon-smileys-average"></i>
                    <p>{{'average' | translate}}</p>
                </a>
            </li>
            <li [ngClass]="{active: requestedMood.mood == 'hard'}" (click)="createMood('hard')">
                <a class="nav-pills-item" href="javascript:void(0)">
                    <i class="icon-smileys-hard"></i>
                    <p>{{'hard' | translate}}</p>
                </a>
            </li>
            <li [ngClass]="{active: requestedMood.mood == 'bad'}" (click)="createMood('bad')">
                <a class="nav-pills-item" href="javascript:void(0)">
                    <i class="icon-smileys-bad"></i>
                    <p>{{'bad' | translate}}</p>
                </a>
            </li>
        </ul>
    </div>
</div>